/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import {
    CashBoxAiClassificationTabAction,
    CashBoxAiClassificationTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxAiClassificationTabActions';
import { AiClassificationsHistoryDto } from '../../../api/apiCommon.typings';

export interface CashBoxAiClassificationTabState {
    aiClassificationsHistory: AiClassificationsHistoryDto;
    isLoadingAiClassificationsHistory: boolean;
    isDownloadingAiClassificationsHistory: boolean;
}
const initialState: CashBoxAiClassificationTabState = {
    aiClassificationsHistory: null,
    isLoadingAiClassificationsHistory: false,
    isDownloadingAiClassificationsHistory: false,
};

export function cashBoxAiClassificationTabReducer(
    state: CashBoxAiClassificationTabState = initialState,
    action: CashBoxAiClassificationTabAction,
): CashBoxAiClassificationTabState {
    switch (action.type) {
        case CashBoxAiClassificationTabActionType.FETCH_AI_CLASSIFICATIONS_HISTORY:
            return {
                ...state,
                isLoadingAiClassificationsHistory: true,
            };

        case CashBoxAiClassificationTabActionType.FETCH_AI_CLASSIFICATIONS_HISTORY_SUCCESS:
            return {
                ...state,
                isLoadingAiClassificationsHistory: false,
                aiClassificationsHistory: action.payload,
            };

        case CashBoxAiClassificationTabActionType.FETCH_AI_CLASSIFICATIONS_HISTORY_ERROR:
            return {
                ...state,
                isLoadingAiClassificationsHistory: false,
                aiClassificationsHistory: {
                    count: 0,
                    items: [],
                },
            };

        case CashBoxAiClassificationTabActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY:
            return {
                ...state,
                isDownloadingAiClassificationsHistory: true,
            };

        case CashBoxAiClassificationTabActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_SUCCESS:
        case CashBoxAiClassificationTabActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_ERROR:
            return {
                ...state,
                isDownloadingAiClassificationsHistory: false,
            };

        case CashBoxAiClassificationTabActionType.EXIT_CASHBOX_AI_CLASSIFICATIONS_TAB:
            return {
                ...state,
                aiClassificationsHistory: null,
            };

        default:
            break;
    }
    return state;
}
